const $ = jQuery.noConflict();

export default function a11yMenu() {
    $("#main-navigation ul li.menu-item-has-children a").on(
        "focusin",
        function onFocusIn(eventObject) {
            eventObject.preventDefault();
            $(this).parent().addClass("hover");
        }
    );

    $("body").on(
        "focusout",
        "#main-navigation ul li.menu-item-has-children.hover ul li:last-child a",
        function onFocusOut(eventObject) {
            eventObject.preventDefault();
            $(this).parent().parent().parent().removeClass("hover");
        }
    );
}
